import type { HTMLAttributes } from 'react';

import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '@/lib/ui/cn';

const surfaceVariants = cva('rounded-[var(--radius-lg)] border', {
  variants: {
    tone: {
      canvas: 'border-[color:var(--bl-line)] bg-[color:var(--bl-canvas)]',
      panel: 'border-[color:var(--bl-line)] bg-[color:var(--bl-panel)] shadow-[var(--bl-shadow)]',
      elevated: 'border-[color:var(--bl-line-strong)] bg-[color:var(--bl-raised)] shadow-[var(--bl-shadow-float)]',
      inset: 'border-[color:var(--bl-line)] bg-[color:var(--bl-sunken)]',
    },
    padding: {
      none: '',
      sm: 'p-3',
      md: 'p-4 sm:p-5',
      lg: 'p-5 sm:p-6',
    },
  },
  defaultVariants: {
    tone: 'panel',
    padding: 'md',
  },
});

export interface SurfaceProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof surfaceVariants> {}

export function Surface({ className, tone, padding, ...props }: SurfaceProps) {
  return <div className={cn(surfaceVariants({ tone, padding }), className)} {...props} />;
}
